import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpContext } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseSvcService } from '../config/base-svc.service';
import { AppOfflineStore } from '../../app.offlineService';

import {
  PowerUserFormData,
  PowerUserRoleFormData,
  PowerUserRoleStatusFormData,
} from 'src/app/Models/user-profiles.model';
import { SessionService } from '../session.service';
import { environment } from 'src/environments/environment';
import { SKIP_LOADER } from 'src/app/Component/Loader/loader.interceptor';
export interface IGetPowerUserDetailsRequest {
  LoggedInUser?: string;
  PowerUserID: string |null;
  EmailAddressOnly: string | null;
  NameOnly: string | null;
  SubjectID: number | null;
}

export interface ICheckDuplicatePayload {
  LoggedInUser?: string
  ID: string | null
  Name: string
  ScreenName: string
}

// Observable operators

@Injectable({
  providedIn: 'root',
})
export class UserManagementService {
  // BASEURL: string = 'http://kochunni69-001-site1.itempurl.com/'

  // BASEURL: string = 'https://www.perfectlearningapp.com';

  //  BASEURL: string = 'http://uat.perfectlearningapp.com'

  //  BASEURL: string = 'https://dev.perfectlearningapp.com'

  BASEURL: string = environment.apiBaseUrl;
  // public activeURL:string = 'http://www.perfectlearningapp.com/';
  // BASEURL:string="http://www.perfectlearningapp.com";
  LOGGED_IN_USER: string = this.session.getUser();
  USER_ID: string = this.session.getUser();
  state: string = 'IND';
  USER_ROLE_ID: string = this.session.getUser();
  Power_User_Role_Ind: string = '';
  Screenurl: string = '';
  // editPowerUserData;
  // editPowerUserRoleData;

  powerUserRoleID: number;
  powerUserId: string;
  PowerUserRoleType: string;
  StatusType: string;
  powerUserStatusTypes: any[];
  public options;

  userStatus: string;
  userName: string;

  constructor(
    private http: HttpClient,
    private config: BaseSvcService,
    public session: SessionService,
    private appserv: AppOfflineStore,
  ) {
    this.options = this.config._httpoption;
  }

  DeletePowerUserRoleSubject(data: any) {
    return this.http.post(
      `${this.BASEURL}/api/user/DeletePowerUserSubject`,
      data
    );
  }

  UpdatePowerUserStatus(data: PowerUserRoleStatusFormData) {
    return this.http.post(
      `${this.BASEURL}/api/InsertOrUpdatePowerUserRoleStatus`,
      data
    );
  }

  modifyUser(data: PowerUserFormData) {
    return this.http.post(`${this.BASEURL}api/InsertOrUpdatePowerUser`, data);
  }

    checkDuplicateEmail(data: ICheckDuplicatePayload) {
      data.LoggedInUser = this.session.getUser();

      return this.http
        .post<any>(this.BASEURL + 'api/GetCheckDuplicate', data, this.options)
    }

  createUserRole(data: any) {
    return this.http.post(
      `${this.BASEURL}/api/InsertOrUpdatePowerUserRole`,
      data
    );
  }

  modifyUserRole(data: PowerUserRoleFormData) {
    data.loggedInUser= this.USER_ROLE_ID;
    return this.http.post(
      `${this.BASEURL}/api/InsertOrUpdatePowerUserRole`,
      data
    );
  }

  getStates(country?:string) {
    return this.http.get(
      `${this.BASEURL}/api/getstates?countrycode=${country?country:this.state}`
    );
  }

  getSubject(category: string) {
    return this.http.get(
      `${this.BASEURL}/api/GetCodes/SUBJECT`
    ).pipe(map((e:any)=> e.resultList ))
  }

  getUsers() {
    return this.http.get(
      `${this.BASEURL}/api/GetPowerUser?loggedInUser=${this.session.getUser()}`
    );
  }
  getPowerUsers(payload:IGetPowerUserDetailsRequest) {
    payload.LoggedInUser = this.session.getUser();
    return this.http.post(
      `${this.BASEURL}/api/GetPowerUserListAll`,payload
    );
  }


  getUserRoleList(payload:any) {
    payload.LoggedInUser= this.session.getUser();
    return this.http.post(
      `${this.BASEURL}/api/GetPowerUserRoleList`,payload
    );
  }

  getCodes(category: string) {
    return this.http.get(`${this.BASEURL}/api/getCodes?category=${category}`);
  }

  addPowerUser(data: PowerUserFormData) {
    return this.http.post(`${this.BASEURL}api/InsertOrUpdatePowerUser`, data);
  }

  getPowerUserById(payload: IGetPowerUserDetailsRequest) {
    payload.LoggedInUser = this.session.getUser()
    return this.http.post(
      `${this.BASEURL}/api/GetPowerUser`,payload
    );
  }

  getPowerUserRoleById(payload: any) {
    payload.LoggedInUser = this.USER_ROLE_ID
    return this.http.post(
      `${this.BASEURL}/api/GetPowerUserRole`,
      payload
    );
  }

  getPowerUserRoleById1(_PowerUserId: any) {
    return this.http.get(
      `${this.BASEURL}/api/GetPowerUserRole?userId=${
        this.LOGGED_IN_USER
      }&powerUserRoleId=${(this.powerUserRoleID = 'undefined'
        ? 0
        : this.powerUserRoleID)}&poweruserid=${_PowerUserId}`
    );
  }

  PowerUserRoleStatusPermission(data: any) {
    return this.http.get(
      `${this.BASEURL}api/GetPowerUserRoleStatusPermission?loggedInUser=${this.USER_ROLE_ID}&actingOnUserRoleType=${data.PowerUserRoleType}&actingOnUserCurrentStatusType=${data.StatusType}`
    );
  }

  userAuthentication(value: any): Observable<any> {
    let bodyString =
      'userName=' +
      value.Username.trim() +
      '&password=' +
      encodeURIComponent(value.Password) +
      '&grant_type=password';
    return this.http.post(`${this.BASEURL}/auth/login`, bodyString, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

refreshToken(refreshToken: string): Observable<any> {
  const bodyString =
    'grant_type=refresh_token&refresh_token=' + encodeURIComponent(refreshToken);

  return this.http.post(
    `${this.BASEURL}/auth/login`,
    bodyString,
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      context: new HttpContext().set(SKIP_LOADER, true) // <- don't show spinner
    }
  );
}

  SendEmailSetPassword(data: any) {
    return this.http.post(`${this.BASEURL}/api/setpassword`, data);
  }

  SendEmailReSetPassword(data: any) {
    return this.http.post(`${this.BASEURL}/api/resetpassword`, data);
  }
}
